import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';

@Component({
  selector: 'app-generic-product-enquiry',
  templateUrl: './generic-product-enquiry.component.html',
  styleUrls: ['./generic-product-enquiry.component.scss'],
  providers:[CompanySetupService,WebServiceService]
})
export class GenericProductEnquiryComponent implements OnInit {
  @Input() modalDetails: any;
  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = {
    "actionsList": [{
      "name": "View",
      "icon": "fa fa-eye",
      "action": "view"
    }],
    "dataList": [],
    "columnList": [],
    "afterdivList": [],
    "beforedivList": [],
    "isProgressing": true,
    "modalDetails": {},
    "dataDetails": {}
  };
  is_recurring:boolean=false
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  company_setup: any = {};
  country_data:any={}
  setup:any={}
  modal_setup:any={}
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  
  constructor(public eesdesService:EesDesService, public webService: WebServiceService, private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,public comanySetup:CompanySetupService) {
    this.initListener();
  }

  ngOnInit() {
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    console.log(this.modalDetails);
    this.setup=this.modalDetails.setup?this.modalDetails.setup:{}
    this.setup.is_setup=this.modalDetails.is_setup?this.modalDetails.is_setup:false;

    if(this.setup.is_setup)
    {
      this.modal_setup=this.setup;
      this.comanySetup.setData(this.modal_setup);
      this.setSetupData(this.setup);
    }
    else
    {
      this.GetCompanySetUpData();
    }

    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }

  GetCompanySetUpData() {
    let req:any={}
    this.company_setup={}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.setSetupData(data.response);
          this.modal_setup=data.response;
          this.comanySetup.setData(this.modal_setup);
      }
      }, error => {

      }
    )
  }

  setSetupData(data)
  {
    this.company_setup=data ? data : {}
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      this.company_setup.product_catalog_id = '1'
    }
    this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
    this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';
    this.company_setup.has_multi_grn_approval = this.company_setup.has_multi_grn_approval ? this.company_setup.has_multi_grn_approval : '0';

    if (this.modalDetails.data) {
      this.apiCall();
    }
    document.getElementById('body').style.overflow = 'hidden';
  }

  apiCall() {
    switch (this.modalDetails.id) {
      case 'prreport':
        this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : this.webService.getMainMenuNameByGivenUrl('/raisepr');
        if(this.modalDetails.action=="view") {
          this.showPr(this.modalDetails.data);
        } else {
          this.modalDetails.pr_items = this.modalDetails.prDataArray ? this.modalDetails.prDataArray : [];
          this.makeFinalData(this.modalDetails.data);
        }
        break;
      default:
        this.toasterService.pop('error', "Error", "Wrong Data");
    }
  }

  showPr(data) {
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "pr_no": data.pr_no }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('pr/ajax_getsingleprdatabypr', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "prreport";
          response.data = response;

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  makeFinalData(response) {
    this.commonVariableList.dataList.push(response)
    this.commonVariableList.modalDetails.is_view = true;
    this.commonVariableList.isProgressing = false;

    if(this.modalDetails.action=="view") {
      
    } else {
      this.modalDetails.pr_items = this.modalDetails.prDataArray ? this.modalDetails.prDataArray : [];
      this.modalDetails.product_enquiry_data = this.modalDetails.product_enquiry_data ? this.modalDetails.product_enquiry_data : [];
      this.modalDetails.businessUnitList = [];
      this.getBusinessUnitDropdown();

      this.modalDetails.productTypeList = [];
      this.getProductTypeDropdown();

      this.modalDetails.qualityList = [];
      this.getQualityDropdown();
      
      let index = 0;
      for(let x of this.modalDetails.product_enquiry_data) {
        x.business_unit = x.business_unit ? x.business_unit : "";

        x.sales_person_name = x.sales_person_name ? x.sales_person_name : "";
        x.customer_mame = x.customer_mame ? x.customer_mame : "";
        x.end_application = x.end_application ? x.end_application : "";
        x.destination_port = x.destination_port ? x.destination_port : "";
        x.packaging = x.packaging ? x.packaging : "";
        x.factory_qa_level = x.factory_qa_level ? x.factory_qa_level : "";

        x.incoterm_id = x.incoterm_id ? x.incoterm_id : "";
        x.incotermsList = [];
        this.getIncotermsDropdown(index);

        x.product_type = x.product_type ? x.product_type : "";
        x.quality = x.quality ? x.quality : "";

        x.certification = x.certification ? x.certification : "";
        x.add_requirement = x.add_requirement ? x.add_requirement : "";

        index++;
      }
    }

    this.commonVariableList.isProgressing = false;
  }

  initListener() {
    document.body.addEventListener('keypress', (event) => this.reset(event));
    document.body.addEventListener('keydown', (event) => this.reset(event));
    document.body.addEventListener('keyup', (event) => this.reset(event));
  }

  reset(event) {
    if (event.keyCode == '27') {
      this.modalDetails.is_view = false;
      document.body.style.overflow = 'auto';
    }
  }

  hideModal() {
    this.modalDetails.is_view = false;
    localStorage.setItem('dataList', '');
    document.getElementById('body').style.overflow = 'auto';
  }

  getBusinessUnitDropdown() {
    this.modalDetails.businessUnitList = [];
    let requestObj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('pro_term/Proterm/getBusinessUnit', requestObj).
      subscribe(
        data => {
          if (data.status) {
            let response = data.response ? data.response : [];
            for (let x of response) {
              this.modalDetails.businessUnitList.push({ "item_id": x, "item_text": x})
            }
          } else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  getIncotermsDropdown(index) {
    this.modalDetails.businessUnitList = [];
    index = index ? index : 0;
    let requestObj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      "index": index,
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('incoterms_masters/ajax_getAllIncoterms', requestObj).
      subscribe(
        data => {
          if (data.status) {
            let response = data.response ? data.response : [];
            for (let x of response) {
              this.modalDetails.product_enquiry_data[index].push({ "item_id": x, "item_text": x})
            }
          } else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  getProductTypeDropdown() {
    this.modalDetails.productTypeList = [];
    let requestObj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('pro_term/Proterm/getProductExistingType', requestObj).
      subscribe(
        data => {
          if (data.status) {
            let response = data.response ? data.response : [];
            for (let x of response) {
              this.modalDetails.productTypeList.push({ "item_id": x, "item_text": x})
            }
          } else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  getQualityDropdown() {
    this.modalDetails.qualityList = [];
    let requestObj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('pro_term/Proterm/getProductQuality', requestObj).
      subscribe(
        data => {
          if (data.status) {
            let response = data.response ? data.response : [];
            for (let x of response) {
              this.modalDetails.qualityList.push({ "item_id": x, "item_text": x})
            }
          } else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.commonVariableList.isProgressing = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2648097449/src/src/app/generic-ui-components/generic-product-enquiry/generic-product-enquiry.component.ts